import React from "react";

import styles from "./tile.module.scss";
import { useI18N } from "@src/language/language-context";

interface TilePropTypes {
  tile: {
    id: string;
    title: string;
    position: string;
    grid_area: string;
    time_period_amount: string;
    time_period_time_unit: string;
  };
  editCallback: () => void;
  deleteCallback: () => void;
}

const cssClassName = "tile";

export const Tile = ({ tile, editCallback, deleteCallback }: TilePropTypes) => {
  const i18n = useI18N();
  const texts = {
    id: i18n("modules.tile.id"),
    title: i18n("modules.tile.title"),
    position: i18n("modules.tile.position"),
    edit: i18n("modules.tile.edit"),
    delete: i18n("modules.tile.delete"),
  };

  const onEditClick = () => {
    editCallback();
  };

  const onDeleteClick = () => {
    deleteCallback();
  };

  return (
    <div className={styles[cssClassName]}>
      <p>
        {texts.id} {tile.id}
      </p>
      <p>
        {texts.title} {tile.title}
      </p>
      <p>
        {texts.position} {tile.position}
      </p>
      <button onClick={onEditClick}>{texts.edit}</button>
      <button onClick={onDeleteClick}>{texts.delete}</button>
    </div>
  );
};
